<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout :titlePage="titlePage" :route="{ name: 'carteira' }">
    <section class="c-receipt">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column is-two-fifths">
          <base-header-page
            :class="{ 'has-background-error': error }"
            class="c-base-header-page--full has-text-white has-background-success"
          >
            <base-icon
              :name="headerIcon"
              class="c-receipt__header-icon"
              width="50"
              height="50"
            />
            <p>
              <strong class="has-text-white is-size-6 is-size-5-tablet">
                <div v-html="title"></div>
              </strong>
            </p>
          </base-header-page>
        </div>
        <div class="column">
          <div class="c-receipt__wrapper has-text-centered">
            <BaseReceiptError v-if="error" :reason="errorReason" />
            <TransactionPixReceiptSuccess
              v-else-if="
                transaction && transaction.reference_id === 'starkbank'
              "
              :transaction="transaction"
            />
          </div>
        </div>
      </div>
      <!-- TypeFormCode -->
      <a
        class="typeform-share button typeform-share-hidden"
        :href="finalUrl"
        data-mode="drawer_right"
        data-auto-open="true"
        data-submit-close-delay="10"
      ></a>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import TransactionPixReceiptSuccess from '@/components/Wallet/TransactionPixReceiptSuccess.vue'
import BaseReceiptError from '@/components/Wallet/BaseReceiptError.vue'

import WalletApi from '@/lib/api/Wallet'

export default {
  components: {
    layout,
    BaseHeaderPage,
    TransactionPixReceiptSuccess,
    BaseReceiptError,
  },

  metaInfo: {
    title: 'Comprovante de solicitação de transferência',
  },

  computed: {
    lastDraw: {
      get() {
        return this.$store.state.wallet.lastDraw
      },
      set(payload) {
        this.$store.dispatch('setLastDraw', payload)
      },
    },

    title() {
      return this.error
        ? 'Houve um problema ao tentar<br>concluir essa solicitação.'
        : 'Solicitação concluída<br> com sucesso!'
    },

    headerIcon() {
      return this.error
        ? 'painel/close-circle-icon'
        : 'painel/check-circle-icon'
    },

    titlePage() {
      return 'Transferência por PIX'
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    walletUpdatedAt: {
      get() {
        return this.$store.state.wallet.walletUpdatedAt
      },
      set(payload) {
        this.$store.dispatch('setWalletUpdatedAt', payload)
      },
    },

    walletSurveys() {
      return this.$store.getters.walletSurveys
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    transactions: {
      get() {
        return this.$store.state.wallet.transactions
      },
      set(payload) {
        this.$store.dispatch('setTransactions', payload)
      },
    },

    transactionsMeta: {
      get() {
        return this.$store.state.wallet.transactionsMeta
      },
      set(payload) {
        this.$store.dispatch('setTransactionsMeta', payload)
      },
    },
  },

  data() {
    return {
      error: false,
      errorReason: '',
      transaction: null,
      baseUrlNonBuyers: 'https://casarcom.typeform.com/to/Ur7JZFTa#',
      baseUrlBuyers: 'https://casarcom.typeform.com/to/hMmPbqnO#',
      params: {
        visitedShoppingBefore: '',
        id: '',
        fiance1: '',
        fiance2: '',
        phone1: '',
        phone2: '',
        email: '',
        saldo: '',
        lista_externa: '',
        quantidade_compra: '',
      },
      finalUrl: '',
      balance: '',
    }
  },

  async created() {
    if (this.lastDraw.type === 'transaction') {
      this.transaction = this.lastDraw
      this.updateWallet()
    }

    // balance - withdraw
    this.balance = this.walletSummary.balance - this.$route.params.value

    if (this.wedSiteInfo) {
      this.setParamsToUrl()
    }

    if (!this.lastDraw && !this.lastDraw.type)
      this.$router.push({ name: 'carteira' })
    else this.setData()
  },

  methods: {
    baseUrl() {
      if (this.walletSummary.balance_shopping > 0) {
        return this.baseUrlBuyers
      }
      return this.baseUrlNonBuyers
    },

    setParamsToUrl() {
      this.params.visitedShoppingBefore =
        'visitou=' +
        (this.walletSummary.owner_full_name && this.walletSummary.owner_cpf
          ? '1'
          : '0')

      this.params.id =
        'wed_id=' +
        (this.logonToken.token_payload.wed_id
          ? this.logonToken.token_payload.wed_id
          : '')

      this.params.fiance1 =
        'noivo1=' +
        (this.wedSiteInfo.noivo1_nome ? this.wedSiteInfo.noivo1_nome : '')

      this.params.fiance2 =
        'noivo2=' +
        (this.wedSiteInfo.noivo2_nome ? this.wedSiteInfo.noivo2_nome : '')

      this.params.phone1 =
        'fone1=' +
        (this.wedSiteInfo.contato_fone1 ? this.wedSiteInfo.contato_fone1 : '')

      this.params.phone2 =
        'fone2=' +
        (this.wedSiteInfo.contato_fone2 ? this.wedSiteInfo.contato_fone2 : '')

      this.params.email =
        'email=' +
        (this.wedSiteInfo.site_email ? this.wedSiteInfo.site_email : '')

      this.params.balance = 'saldo=' + (this.balance ? this.balance : '0')

      this.params.has_external_gift_list =
        'lista_externa=' +
        (this.wedSiteInfo.has_external_gift_list
          ? this.wedSiteInfo.has_external_gift_list
          : false)

      this.quantidade_compra =
        this.walletSummary.balance_shopping > 0
          ? `'&quantidade_compra='${this.walletSummary.count_shopping}`
          : '0'

      this.finalUrl =
        this.baseUrl() +
        this.params.visitedShoppingBefore +
        '&' +
        this.params.id +
        '&' +
        this.params.fiance1 +
        '&' +
        this.params.fiance2 +
        '&' +
        this.params.phone1 +
        '&' +
        this.params.phone2 +
        '&' +
        this.params.email +
        '&' +
        this.params.balance +
        '&' +
        this.params.has_external_gift_list +
        this.quantidade_compra
    },

    getWithdrawReason() {
      //TypeFormCode
      let js,
        q,
        d = document,
        gi = d.getElementById,
        ce = d.createElement,
        gt = d.getElementsByTagName,
        id = 'typef_orm_share',
        b = 'https://embed.typeform.com/'
      if (!gi.call(d, id)) {
        js = ce.call(d, 'script')
        js.id = id
        js.src = b + 'embed.js'
        q = gt.call(d, 'script')[0]
        q.parentNode.insertBefore(js, q)
      }
    },

    surveyPresented() {
      if (!this.walletSurveys.withdraw_presented_at) {
        const walletApi = new WalletApi(this.logonToken)
        walletApi
          .setSurveyPresented()
          .catch(console.warn('Set Survey presented failed'))
          .finally(() => {})
      }
    },

    surveyAfterShoppingOrderPresented() {
      if (!this.walletSurveys.withdraw_after_shopping_order_presented_at) {
        const walletApi = new WalletApi(this.logonToken)
        walletApi
          .setSurveyAfterShoppingOrderPresented()
          .catch(console.warn('Set Survey presented failed'))
          .finally(() => {})
      }
    },

    setData() {
      if (this.lastDraw.type === 'transaction') {
        // Show Survey only if user has shopping and not answered it before( Buyers)
        if (
          !this.walletSurveys.withdraw_after_shopping_order_presented_at &&
          this.walletSummary.balance_shopping > 0 // withdraw using pix
        ) {
          this.getWithdrawReason()
          this.surveyAfterShoppingOrderPresented()
        } else if (
          // (not answered it before (Non Buyers))
          !this.walletSurveys.withdraw_after_shopping_order_presented_at &&
          !this.walletSurveys.withdraw_presented_at //withdraw using pix
        ) {
          this.getWithdrawReason()
          this.surveyPresented()
        }
      } else if (this.lastDraw.type === 'error') {
        this.errorReason = this.lastDraw.reason
        this.error = true
      } else return this.$router.push({ name: 'carteira' })
      this.lastDraw = {}
    },

    updateWallet() {
      const walletApi = new WalletApi(this.logonToken)

      walletApi.getTransactions().then((response) => {
        const transactions = response?.data
        if (transactions) {
          this.transactions = transactions.data
          this.transactionsMeta = transactions.meta
        }
      })

      walletApi.getSummary().then((walletSummary) => {
        this.walletSummary = walletSummary
        this.walletUpdatedAt = new Date()
      })
    },
  },
}
</script>

<style lang="scss">
.c-receipt {
  &__header-icon {
    @media (min-width: $tablet) {
      width: 110px;
      height: 110px;
    }
  }

  &__wrapper {
    padding: 2em 12px 0;
    margin: 0 auto;
    max-width: 420px;
  }

  .c-base-summary {
    margin: 2em auto;

    &__wrapper {
      padding: 18px 0;
      margin: 0 auto;
      max-width: 320px;
    }

    &__content-bordered {
      position: relative;
      &:before {
        content: '';
        @include position(absolute, auto, 0, -6px, auto);
        width: 100px;
        height: 1px;
        background-color: $gray-3;
      }
    }
  }
}

.typeform-share-hidden {
  display: none;
}
</style>
